import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

const TrailDetailsLegendeBrskova = () => {
  // Natural attractions with GPS coordinates and Cloudinary images
  const naturalAttractions = [
  {
    id: 'planina-bjelasica',
    name: 'Planina Bjelasica',
    gps: '42.8996466097489, 19.59746579794505',
    description: `Pitoma ljepotica koja se naslanja na čak četiri opštine ‒ Mojkovac, Kolašin, Berane i Bijelo Polje, drugačija je od klasičnog crnogorskog kraškog modela planina. Bogata je pašnjacima i gustim, pretežno listopadnim šumama, preovladavaju lako dostupni travnati vrhovi i fantastični pogledi na susjedne masive.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228191/Fotografija_2.1_-_Bjelasica_pejza%C5%BE_yuvxcc.jpg",
    imageAlt: 'Planina Bjelasica sa pitomim travnatim vrhovima i gustim šumama'
  }];


  // Cultural-historical attractions with GPS coordinates and Cloudinary images
  const culturalAttractions = [
  {
    id: 'spomenik-mojkovacka-bitka-bojna-njiva',
    name: 'Spomenik junacima Mojkovačke bitke na Bojnoj njivi',
    gps: '42.972561575543686, 19.599484985997087',
    description: `Bojna njiva, mjesto odigravanja Mojkovačke bitke koja se desila na Božić 1916. godine, kada je vojska Kraljevine Crne Gore uspješno zaustavila austrougarsku ofanzivu. Na ovom mjestu je postavljen spomenik sa sljedećim natpisom: "Mi smo pali da bi Crna Gora i Srbija živjele".`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228191/Fotografija_2.2_-_spomenik_Mojkova%C4%8Dke_bitke_2_j87gkz.jpg",
    imageAlt: 'Spomenik junacima Mojkovačke bitke na Bojnoj njivi sa natpisom o padu za slobodu'
  },
  {
    id: 'medeno-guvno',
    name: 'Medeno guvno',
    gps: '42.95386321175142, 19.62821227866103',
    description: `Medeno guvno, lokalitet na kojem se nalazi groblje junaka Mojkovačke bitke.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763227254/KOSANINOVA_JEZERA_2.3_izvor_studenica_info_txpfmp.jpg",
    imageAlt: 'Lokalitet Medeno guvno - groblje junaka Mojkovačke bitke'
  },
  {
    id: 'spomenik-mojkovacka-bitka-ulaz',
    name: 'Spomenik Mojkovačke bitke na ulazu u Mojkovac',
    gps: '42.95660139973145, 19.577385132211212',
    description: `Spomenik junacima Mojkovačke bitke je podignut 1966. godine i na svakoj strani spomenika se nalaze bronzane reljefne skulpture. Ispod nastrešnice, na mermernoj ploči uklesan je natpis: "Junacima Mojkovačke bitke – ginuli su za slobodu i bratstvo, zato i danas žive, 1915-16 – 1966".`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228192/Fotografija_2.3_-_spomenik_Mojkova%C4%8Dke_bitke_na_ulazu_u_Mojkovac_tylzni.jpg",
    imageAlt: 'Spomenik Mojkovačke bitke na ulazu u Mojkovac sa bronzanim reljefnim skulpturama'
  },
  {
    id: 'spomenik-serdar-janko-vukotic',
    name: 'Spomenik serdaru Janku Vukotiću u Mojkovcu',
    gps: '42.96199734676632, 19.57932166827307',
    description: `Spomenik u centru grada podignut je serdaru pod čijom komandom je crnogorska vojska 9. oktobra 1912. godine oslobodila Mojkovac, poslije viševjekovnog ropstva. Serdar Janko Vukotić bio je komandant Crnogorsko-sandžačke vojske u Prvom svjetskom ratu i komandovao crnogorskom vojskom u Mojkovačkoj bici, na Božić 1916. godine.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228192/Fotografija_2.4_-_spomenik_serdaru_Janku_Vukoti%C4%87u_hyaypo.jpg",
    imageAlt: 'Spomenik serdaru Janku Vukotiću u centru Mojkovca'
  },
  {
    id: 'stari-most-tara',
    name: 'Stari most na Tari',
    gps: '42.95667872415609, 19.57667025162501',
    description: `Stari kameni most na rijeci Tari na ulazu u Mojkovac jedan je od simbola grada. Pušten je u saobraćaj 1934. godine, a njegova izgradnja je trajala dvije godine. Prema predanju, most su gradili Dalmatinci, "jer su oni jedini znali da rade sa kamenom".`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763503298/Stari-most-Mojkovac_fs_h4pgnj.jpg",
    imageAlt: 'Stari kameni most na rijeci Tari - simbol grada Mojkovca'
  },
  {
    id: 'zavicajni-muzej-bijelo-polje',
    name: 'Zavičajni muzej Bijelo Polje',
    gps: '43.032945582108006, 19.74573678586493',
    description: `Riznica Zavičajnog muzeja otkriva kako se razvijao bjelopoljski kraj još od prvih praistorijskih naseobina, pa sve do danas. Muzej čuva i dio zaostavštine najpoznatije bjelopoljske porodice Lazović – tri generacije slikara. Također, jako važna postavka jesu alati koje su vješti rudari Sasi koristili u srednjem vijeku, u potrazi za srebrom u rudniku Brskovo.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763503377/Zavicajni-muzej-Bijelo-Polje_fs_ys8jri.jpg",
    imageAlt: 'Zavičajni muzej Bijelo Polje sa vrijednom kolekcijom srednjovjekovnih eksponata'
  },
  {
    id: 'manastir-majstorovina',
    name: 'Manastir Majstorovina, Bijelo Polje',
    gps: '42.961973259995524, 19.722082867661292',
    description: `Manastir Majstorovina sa crkvom posvećenom Sv. Trojici se nalazi u istoimenom selu u blizini Bijelog Polja. Manastirsko imanje je na desnoj obali rijeke Bistrice, na blago uzdignutoj zaravni, dok prostor koji okružuje manastir oduševljava sve posjetioce. Natpis nad ulaznim vratima manastira Svete Trojice govori da je sazidan u 14. vijeku.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228195/Fotografija_2.5_-_manastir_Majstorovina_yb6bdq.jpg",
    imageAlt: 'Manastir Majstorovina sa crkvom Svete Trojice iz 14. vijeka okružen zelenilom'
  },
  {
    id: 'manastir-nikoljac',
    name: 'Manastir Nikoljac, Bijelo Polje',
    gps: '43.02629505869732, 19.73994874469818',
    description: `Manastir posvećen Svetom Nikoli podignut je na području grada koji se zove Nikoljac ‒ ovdje su svraćali mnogi karavani, kako bi odmorili, prodavali ili trampili robu. U manastirskoj crkvi potpuno su očuvane freske iz 16. vijeka, a najinteresantnije freske prikazuju zagrobni život prema narodnom vjerovanju.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763226351/2.6_gvfq36.jpg",
    imageAlt: 'Manastir Nikoljac sa očuvanim freskama iz 16. vijeka'
  },
  {
    id: 'crkva-svetih-apostola',
    name: 'Crkva Svetih apostola Petra i Pavla, Bijelo Polje',
    gps: '43.03570722328274, 19.7448103689503',
    description: `Crkvu Svetih apostola Petra i Pavla je 1196. godine podigao humski knez Miroslav, brat velikog župana Stefana Nemanje. Ovo mjesto je bilo središte iz kog je, prije 800 godina, počelo da se širi i razvija naselje, današnje Bijelo Polje. Za crkvu Svetog Petra i Pavla vezan je i jedan od najvažnijih pokretnih spomenika svjetske kulturne baštine ‒ Miroslavljevo jevanđelje.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228199/Fotografija_2.7_-_crkva_Svetih_apostola_ttkf4g.jpg",
    imageAlt: 'Crkva Svetih apostola Petra i Pavla iz 1196. godine - najstariji spomenik kulturne baštine'
  },
  {
    id: 'manastir-voljavac',
    name: 'Manastir Voljavac, Bijelo Polje',
    gps: '43.114267038640065, 19.78495623833781',
    description: `Manastirski hram posvećen Rođenju Presvete Bogorodice nalazi se na ušću rijeke Bistrice u Lim. Zadužbina je velikog župana Stefana Nemanje (12. vijek). Turci su porušili crkvu u 18. vijeku i od njenih ostataka napravili most na Bistrici.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228220/Fotografija_2.8_-manastir_Voljevac_tg424q.jpg",
    imageAlt: 'Manastir Voljavac - zadužbina Stefana Nemanje na ušću Bistrice u Lim'
  },
  {
    id: 'manastir-podvrh',
    name: 'Manastir Podvrh, Bijelo Polje',
    gps: '43.06986626326031, 19.90246133280189',
    description: `Manastir Podvrh je udaljen 25 kilometara od Bijelog Polja, podignut je pored izvora rijeke Bistrice. Crkva posvećena Svetom Nikoli sazidana je 1606. godine. Živopis je djelo poznatog popa Strahinje iz Budimlje, u periodu 1613/14. godine.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228202/Fotografija_2.9_-_manastir_Podvrh_nfegi6.jpg",
    imageAlt: 'Manastir Podvrh sa crkvom Svetog Nikole iz 1606. godine pored izvora Bistrice'
  },
  {
    id: 'polimski-muzej-berane',
    name: 'Polimski muzej Berane',
    gps: '42.844063377434324, 19.872580210240166',
    description: `Muzej je otvoren 1955. godine sa ciljem da predstavi materijal koji svjedoči o ljudskom postojanju na području Gornjeg Polimlja od doba mezolita (9000 – 6000 godina prije nove ere) do danas. Bogat materijal, više od 10.000 muzejskih predmeta, podijeljen je u nekoliko zbirki.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763503510/polimski-muzej-berane_bdus6f.jpg",
    imageAlt: 'Polimski muzej Berane sa bogatom kolekcijom od preko 10.000 eksponata'
  },
  {
    id: 'manastir-sudikova',
    name: 'Manastir Šudikova, Berane',
    gps: '42.8705291, 19.8706063',
    description: `Nalazi se na desnoj obali Lima, na početku Tifranske klisure kod Berana. Posvećen je Vavedenju Presvete Bogorodice. Prvi put pominje se u 16. vijeku, ali se ne zna kada je tačno osnovan. Manastir je poznat kao srednjovjekovni centar rukopisanja i fresko-ikonopisačke škole.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228223/Fotografija_2.10_-_manastir_%C5%A0udikova_oysori.jpg",
    imageAlt: 'Manastir Šudikova na desnoj obali Lima - centar srednjovjekovnog rukopisanja'
  },
  {
    id: 'manastir-djurdjevi-stupovi',
    name: 'Manastir Đurđevi stupovi, Berane',
    gps: '42.8528178, 19.8607453,15',
    description: `Manastir je zadužbina Stefana Prvoslava (1174‒1244), sina velikog župana Tihomira, najstarijeg brata Stefana Nemanje, i njegov se grob nalazi unutar manastira. Gradnja je završena 1213. godine. Sveti Sava je 1219. godine uspostavio Budimljansku episkopiju i u hramu posvećenom Sv. velikomučeniku Georgiju ustoličio prvog budimljanskog episkopa.`,
    image: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763228220/Fotografija_2.11_-_manastir_%C4%90ur%C4%91evi_stupovi1_k5kfcl.jpg",
    imageAlt: 'Manastir Đurđevi stupovi - zadužbina Stefana Prvoslava iz 1213. godine'
  }];


  // Itinerary details
  const itinerary = {
    day1: {
      title: 'DAN 1',
      route: 'Mojkovac – Brskovo – Bijelo Polje',
      activities: [
      'Mojkovac – planinarski dom Džambas, prati se planinarska Via Dinarica u dužini od 8,6 km i 630 m visinske razlike',
      'Obilazak u toku dolaska lokaliteta Bojne njive, vezanog za čuvenu Mojkovačku bitku i Medenog guvna, groblja boraca Mojkovačke bitke',
      'Obilazak lokaliteta i arheoloških ostataka srednjovjekovnog grada Brskova rutom tematske staze "Legende i priče iz srednjovjekovnog Brskova"',
      'Vožnja od Mojkovca do Bijelog Polja, 30 minuta',
      'Obilazak Zavičajnog muzeja Bijelo Polje sa zbirkom arheoloških ostataka iz rudnika Brskovo',
      'Obilazak crkve Nikoljac, srednjovjekovnog manastira iz 13. vijeka',
      'Obilazak crkve Sv. Petra i Pavla iz koje potiče najznačajniji sačuvani manuskript, Miroslavljevo jevanđelje iz 12. vijeka']

    },
    day2: {
      title: 'DAN 2',
      route: 'Bijelo Polje – Berane',
      activities: [
      'Pješačka tura sa obilaskom manastira Voljavac, na početku staze i manastira Podvrh, na kraju staze',
      'Vožnja od Bijelog Polja do manastira Majstorovina, 20 minuta',
      'Obilazak manastira Majstorovina, uzorne manastirske ekonomije, smještenog u idiličnom planinskom kraju',
      'Vožnja od Majstorovine do Berana, 45 minuta',
      'Obilazak Polimskog muzeja, sa vrijednim zbirkama',
      'Obilazak dva izuzetno značajna manastira: Đurđevi stupovi i Šudikova']

    }
  };

  // Service providers
  const serviceProviders = [
  {
    id: 'tara-riverside',
    name: 'Tara Riverside',
    address: 'Junaka mojkovačke bitke 21, Mojkovac',
    phone: '+382 67 940 542',
    email: 'tarariverside.mojkovac@gmail.com',
    gps: '42.95633686753435, 19.5774925276031',
    description: 'Tara Riverside se nalazi na obali Tare, ima pogled na Stari most i rijeku. Raspolažu sa 4 bungalova koji imaju terasu i sopstveno kupatilo, ukupan kapacitet 12 mjesta.'
  },
  {
    id: 'etno-selo-zuric',
    name: 'Etno selo Žurić',
    address: 'Bjelojevićki put 7, Bjelovići, Mojkovac',
    phone: '+382 69 325 345',
    email: 'etnoselozuric@gmail.com',
    gps: '42.93552602163489, 19.59510095452047',
    description: 'Smješteno u zaseoku na padini Bjelasice, etno selo Žurić pruža fantastičan pogled na dolinu Mojkovca. U ponudi je smještajni kapacitet od ukupno 14 ležajeva.'
  },
  {
    id: 'imanje-medojevic',
    name: 'Imanje Medojević',
    address: 'Bojna Njiva, Mojkovac',
    phone: '+382 69 102 619',
    email: 'miroslavmedojevic@yahoo.com',
    gps: '42.96500745709161, 19.59068703729998',
    description: 'Adaptacija seoske porodične kuće je donijela jedinstven smještaj i iskustvo za sve koji posjete imanje porodice Medojević.'
  },
  {
    id: 'seosko-domacinstvo-vukadinovic',
    name: 'Seosko domaćinstvo Vukadinović',
    address: 'Bojna Njiva, Mojkovac',
    phone: '+382 67 438 678',
    gps: '42.96954378463994, 19.596206055688906',
    description: 'Kategorizovano kao seosko domaćinstvo sa tri zvjezdice od 2013. godine, ima smještajni kapacitet od 7 kreveta.'
  },
  {
    id: 'planinarski-dom-dzambas',
    name: 'Planinarski dom Džambas',
    address: 'katun Mučnica, Bjelasica, Mojkovac',
    phone: '+382 67 554 351',
    gps: '42.94238711846082, 19.641637318389446',
    description: 'Planinarski dom Džambas se nalazi na Bjelasici, ispod vrha Mučnica. Smještajni kapacitet čini ukupno 50 ležajeva.'
  }];


  return (
    <>
      <Helmet>
        <title>Legende i priče iz srednjovjekovnog Brskova - Creative Twinning</title>
        <meta
          name="description"
          content="Otkrijte legende srednjovjekovnog Brskova, važnog rudarskog i trgovačkog centra. Istražite planinu Bjelasicu, spomenike Mojkovačke bitke i bogato kulturno nasljeđe ovog kraja kroz dvodnevnu tematsku stazu." />

        <meta name="keywords" content="Brskovo, srednjovijek, Bjelasica, Mojkovačka bitka, manastiri, kulturno nasleđe, Montenegro" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <section className="relative h-96 overflow-hidden">
            <Image
              src="https://images.unsplash.com/photo-1665683189796-097b98fe8867"
              alt="Planina Bjelasica sa pitomim travnatim vrhovima i gustim šumama"
              className="w-full h-full object-cover" />

            <div className="absolute inset-0 bg-black/40" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white px-6">
                <h1 className="font-heading text-4xl md:text-6xl font-bold mb-4">
                  Legende i priče iz srednjovjekovnog Brskova
                </h1>
                <p className="text-xl md:text-2xl font-medium opacity-90">
                  Putovanje kroz vrijeme i istoriju
                </p>
              </div>
            </div>
          </section>

          {/* Trail Info & Navigation */}
          <section className="py-8 border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <Link
                    to="/thematic-trails-overview"
                    className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">

                    <Icon name="ArrowLeft" size={20} />
                    <span>Nazad na sve staze</span>
                  </Link>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Route" size={16} />
                    <span>5.4 km</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Clock" size={16} />
                    <span>2 dana</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-warning">
                    <Icon name="TrendingUp" size={16} />
                    <span>Umjereno</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Introduction */}
          <section className="py-12">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="prose prose-lg max-w-none">
                <p className="text-lg leading-relaxed text-muted-foreground">
                  Drugu tematsku stazu možemo nazvati i stazom legendi, jer vas, poput vremeplova, vraća u srednji vijek ‒ u doba Brskova, važnog srednjovjekovog rudarskog i trgovačkog centra. Za Brskovo, na 6 kilometara od Mojkovca, na padini planine Bjelasice, vezuje se rudnik srebra, prvi iskovan novac, priče o karavanima, trgovini i životu tog doba. Ovdašnje stanovništvo je imalo i goste ‒ vješte germanske rudare Sase koji su donijeli razvijenu tehnologiju rudarske proizvodnje. Priuštite sebi putovanje kroz istoriju, otkrijte zanimljive lokalitete koje ćemo vam predstaviti u nastavku, a da ne zaboravimo: tu je i planina Bjelasica. Otkrijte njene čari krstareći mrežom planinarskih i biciklističkih staza.
                </p>
              </div>
            </div>
          </section>

          {/* Natural Attractions */}
          <section className="py-12 bg-muted/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="font-heading text-3xl font-bold text-center mb-12">Prirodne atrakcije</h2>
              <div className="grid gap-8">
                {naturalAttractions?.map((attraction) =>
                <div key={attraction?.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="md:flex">
                      <div className="md:w-1/3">
                        <Image
                        src={attraction?.image}
                        alt={attraction?.imageAlt}
                        className="w-full h-64 md:h-full object-cover" />

                      </div>
                      <div className="md:w-2/3 p-6">
                        <div className="flex items-start justify-between mb-4">
                          <h3 className="font-heading text-xl font-semibold">{attraction?.name}</h3>
                          <div className="flex items-center gap-1 text-sm text-muted-foreground">
                            <Icon name="MapPin" size={16} />
                            <span className="font-mono text-xs">{attraction?.gps}</span>
                          </div>
                        </div>
                        <p className="text-muted-foreground leading-relaxed">{attraction?.description}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Cultural-Historical Attractions */}
          <section className="py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="font-heading text-3xl font-bold text-center mb-12">Kulturno-istorijske atrakcije</h2>
              <div className="grid gap-8">
                {culturalAttractions?.map((attraction) =>
                <div key={attraction?.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="md:flex">
                      <div className="md:w-1/3">
                        <Image
                        src={attraction?.image}
                        alt={attraction?.imageAlt}
                        className="w-full h-64 md:h-full object-cover" />

                      </div>
                      <div className="md:w-2/3 p-6">
                        <div className="flex items-start justify-between mb-4">
                          <h3 className="font-heading text-xl font-semibold">{attraction?.name}</h3>
                          <div className="flex items-center gap-1 text-sm text-muted-foreground">
                            <Icon name="MapPin" size={16} />
                            <span className="font-mono text-xs">{attraction?.gps}</span>
                          </div>
                        </div>
                        <p className="text-muted-foreground leading-relaxed">{attraction?.description}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Itinerary */}
          <section className="py-12 bg-muted/30">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="font-heading text-3xl font-bold text-center mb-12">
                Predlog 2-dnevnog obilaska: Legende i priče iz srednjeg vijeka
              </h2>
              
              <div className="space-y-8">
                {/* Day 1 */}
                <div className="bg-white rounded-xl shadow-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold text-sm">
                      1
                    </div>
                    <h3 className="font-heading text-xl font-semibold">{itinerary?.day1?.title}</h3>
                  </div>
                  <p className="text-muted-foreground mb-4 font-medium">{itinerary?.day1?.route}</p>
                  <ul className="space-y-3">
                    {itinerary?.day1?.activities?.map((activity, index) =>
                    <li key={index} className="flex items-start gap-3">
                        <Icon name="ArrowRight" size={16} className="text-primary mt-1 flex-shrink-0" />
                        <span className="text-muted-foreground">{activity}</span>
                      </li>
                    )}
                  </ul>
                </div>

                {/* Day 2 */}
                <div className="bg-white rounded-xl shadow-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold text-sm">
                      2
                    </div>
                    <h3 className="font-heading text-xl font-semibold">{itinerary?.day2?.title}</h3>
                  </div>
                  <p className="text-muted-foreground mb-4 font-medium">{itinerary?.day2?.route}</p>
                  <ul className="space-y-3">
                    {itinerary?.day2?.activities?.map((activity, index) =>
                    <li key={index} className="flex items-start gap-3">
                        <Icon name="ArrowRight" size={16} className="text-primary mt-1 flex-shrink-0" />
                        <span className="text-muted-foreground">{activity}</span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Service Providers */}
          <section className="py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="font-heading text-3xl font-bold text-center mb-12">
                Gdje se okrijepiti, jesti ili prespavati?
              </h2>
              <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {serviceProviders?.map((provider) =>
                <div key={provider?.id} className="bg-white rounded-xl shadow-lg p-6">
                    <h3 className="font-heading text-lg font-semibold mb-3">{provider?.name}</h3>
                    <div className="space-y-2 text-sm text-muted-foreground mb-4">
                      <div className="flex items-start gap-2">
                        <Icon name="MapPin" size={16} className="mt-0.5 flex-shrink-0" />
                        <span>{provider?.address}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Icon name="Phone" size={16} />
                        <span>{provider?.phone}</span>
                      </div>
                      {provider?.email &&
                    <div className="flex items-center gap-2">
                          <Icon name="Mail" size={16} />
                          <span>{provider?.email}</span>
                        </div>
                    }
                      <div className="flex items-start gap-2">
                        <Icon name="Navigation" size={16} className="mt-0.5 flex-shrink-0" />
                        <span className="font-mono text-xs">{provider?.gps}</span>
                      </div>
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">{provider?.description}</p>
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-12 bg-primary text-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <h2 className="font-heading text-3xl font-bold mb-4">
                Spremni za putovanje kroz srednjovjekovnu istoriju?
              </h2>
              <p className="text-xl mb-8 opacity-90">
                Otkrijte legende Brskova i uronite u bogato kulturno nasljeđe ovog kraja
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button variant="secondary" size="lg" iconName="Map" asChild>
                  <Link to="/heritage-interactive-map">
                    Pogledaj na mapi
                  </Link>
                </Button>
                <Button variant="outline" size="lg" iconName="ArrowLeft" asChild>
                  <Link to="/thematic-trails-overview" className="text-white border-white hover:bg-white hover:text-primary">
                    Sve tematske staze
                  </Link>
                </Button>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>);

};

export default TrailDetailsLegendeBrskova;